import { Box, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from '@mui/material'
import React, { useState, useEffect } from 'react'
import TriggerApiOnView from './TriggerApiOnView'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { ToolsFieldWithMic } from '../../../../Components/Common Components/CommonComponents';
import { formatDateAndTime, formatDateAndTimeMeth2 } from '../../../../Components/CommonFunctions/CommonFunctions';
import { ImagePaths } from '../../../../Utility/ImagePaths';

const radPrintEnable = new Set(["Result Saved", "Completed", "Dispatched"])
export default function CollabDischargeSum(props) {
    const { id, isProgrammaticScroll, userData, details } = props;

    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [dislayOut, setdislayOut] = useState([]);
    const [disSumData, setdisSumData] = useState([]);
    const [patient_id, setpatient_id] = useState(null);
    const [valDisSum, setvalDisSum] = useState({});
    const [isRadPrint, setisRadPrint] = useState(false);
    useEffect(() => {
        try {
            const cachedData = getCachevalue('DoctorPatientData');
            const appointData = JSON.parse(cachedData);
            if (appointData?.patient_id) {
                setpatient_id(appointData.patient_id);
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }, []);

    const getDisSumLayout = () => {
        try {
            RestAPIService.getAll(`${Serviceurls.DIS_SUM_LAYOUT}?clinic_id=${getCachevalue('SelectedDoctorClinic')}`)
                .then(response => {
                    if (response.data.status === 'success') {
                        setdislayOut(response.data.data)
                        getDischargeSum(response.data.data)
                    }
                }).catch(e => {
                    if (e.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getDischargeSum = (layout) => {
        try {
            RestAPIService.getAll(`${Serviceurls.IP_DIS_SUM_POST}?clinic_id=${getCachevalue('SelectedDoctorClinic')}&patient_id=${patient_id}&ip_admission_id=${details?.admission_id}`)
                .then(response => {
                    if (response.data.status === 'success') {
                        setdisSumData(response.data.data || [])
                        appendData(response.data.data, layout)
                    }
                }).catch(e => {
                    if (e.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const appendData = (data, layout) => {
        if (data.length == 1) {
            var tem_json = data[0].template_data
            var data1 = layout.filter((item) => (item.id == data.map((item) => item.layout_id)))
            var keys = {}
            data1[0]?.dis_sum_json?.forEach((element) => {
                keys[element.field_name] = tem_json[element.field_name]
            })
            setvalDisSum(keys)
        }
    };


    const getDisSumData = (section) => {
        switch (section) {
            case "DisSummary":
                getDisSumLayout()
                break;
            default:
                break;
        }
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
    }
    const errorMessage = (msg) => {
        seterrorMsg(true)
        seterrorMsgText(msg)
    }
    const textView = (label, val) => {
        return (
            <ToolsFieldWithMic
                FromTestReport={true}
                isFrom={"dischargeSummary"}
                EditorDisable={true}
                Title={label}
                EditorRef={val || ''}
                overallHeight={"auto"}
                EditorHeight={"auto"}
                micTextEditDisabled={true}
                errorMsg={errorMessage.bind(this)}
            />
        )
    }
    const printRadiologyTest = (id, radiology_id) => {
        try {
            RestAPIService.PrintPDF((localGetItem("isNewBilling") === "true" ? Serviceurls.NEW_RAD_RESULT_PRINT : Serviceurls.RAD_RESULT_PRINT) + '?id=' + id + "&radiology_id=" + radiology_id +
                "&export_type=pdf" + `&clinic_id=${getCachevalue('SelectedDoctorClinic')}`)
                .then((response) => {
                    if (response) {
                        //Create a Blob from the PDF Stream
                        const file = new Blob(
                            [response.data],
                            { type: 'application/pdf' });
                        //Build a URL from the file
                        const fileURL = URL.createObjectURL(file);
                        //Open the URL on new Window
                        window.open(fileURL);
                        setisRadPrint(false)
                    }
                }).catch((e) => {
                    setisRadPrint(false)
                    if (e.response?.data?.status === "fail") {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisRadPrint(false)
            errorMessage(e.message)
        }
    }
    let datalabel = []
    if (dislayOut.length > 0 && disSumData.length > 0) {
        datalabel = dislayOut.filter((item) => (item.id == disSumData.map((item) => item.layout_id)))
    }
    return (
        <Box marginLeft={'1vw'}>
            <Typography fontSize={'1vw'} fontWeight={'bold'}>Discharge Summary</Typography>
            <TriggerApiOnView id={`DisSummary_${id}`} onEnterView={(id) => getDisSumData(id)} isProgrammaticScroll={isProgrammaticScroll}>
                <Box id={`DisSummary_${id}`}>
                    {datalabel.length === 1 ? datalabel[0]?.dis_sum_json?.map((item) => {
                        if (item.label === "Medication" && item.is_active === true) {
                            return (
                                <Box marginTop={'.5vw'}>
                                    <Typography fontSize={'1vw'} fontWeight={'bold'} >{'Medication'}</Typography>
                                    <Paper>
                                        <TableContainer>
                                            <Table size='small' aria-label="stictbl">
                                                <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                    <TableRow>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '5vw' }}>S.No</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '25vw' }}>Medication Name</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>Dosage/Strength</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>Timing</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>Route</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>Instruction</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {valDisSum.medication?.length > 0 ? valDisSum.medication?.map((list, i) => (
                                                        <TableRow>
                                                            <TableCell sx={{ width: '5vw' }}>{i + 1}</TableCell>
                                                            <TableCell sx={{ width: '25vw' }}>{list.medicinename || '-'}</TableCell>
                                                            <TableCell sx={{ width: '20vw' }}>{list.dosage || '-'}</TableCell>
                                                            <TableCell sx={{ width: '10vw' }}>{list.maen || '-'}</TableCell>
                                                            <TableCell sx={{ width: '20vw' }}>{list.route || '-'}</TableCell>
                                                            <TableCell sx={{ width: '20vw' }}>{list.instruction || '-'}</TableCell>
                                                        </TableRow>
                                                    )) : <TableCell colSpan={5}>{`No Records to Be Shown`}</TableCell>}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Box>
                            )

                        } else if (item.label === "Discharge Instruction" && item.is_active === true) {
                            return (
                                <Box marginTop={'.5vw'}>
                                    <Typography fontSize={'1vw'} fontWeight={'bold'} >{`Discharge Instruction`}</Typography>
                                    <Box marginLeft={'1vw'}>
                                        <Box>
                                            {textView(`Diet`, valDisSum?.discharge_instruction?.diet)}
                                        </Box>
                                        <Box>
                                            {textView(`Activity`, valDisSum?.discharge_instruction?.acivity)}
                                        </Box>
                                        <Box>
                                            {textView(`Advice on discharge`, valDisSum?.discharge_instruction?.advice_discharge)}
                                        </Box>
                                    </Box>

                                </Box>
                            )
                        } else if (item.label === "In Hospital Medication" && item.is_active === true) {
                            return (
                                <Box marginTop={'.5vw'}>
                                    <Typography fontSize={'1vw'} fontWeight={'bold'} >{'In Hospital Medication'}</Typography>
                                    <Paper>
                                        <TableContainer>
                                            <Table size='small' aria-label="stictbl">
                                                <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                    <TableRow>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '5vw' }}>S.No</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '25vw' }}>Medication Name</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>Dosage/Strength</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '10vw' }}>Timing</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>Route</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>Instruction</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {valDisSum.in_hospital_medication?.length > 0 ? valDisSum.in_hospital_medication?.map((list, i) => (
                                                        <TableRow>
                                                            <TableCell sx={{ width: '5vw' }}>{i + 1}</TableCell>
                                                            <TableCell sx={{ width: '25vw' }}>{list.medicinename || '-'}</TableCell>
                                                            <TableCell sx={{ width: '20vw' }}>{list.dosage || '-'}</TableCell>
                                                            <TableCell sx={{ width: '10vw' }}>{list.maen || '-'}</TableCell>
                                                            <TableCell sx={{ width: '20vw' }}>{list.route || '-'}</TableCell>
                                                            <TableCell sx={{ width: '20vw' }}>{list.instruction || '-'}</TableCell>
                                                        </TableRow>
                                                    )) : <TableCell colSpan={5}>{`No Records to Be Shown`}</TableCell>}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Box>

                            )
                        } else if (item.label === 'Admission Diagnosis' && item.is_active === true) {
                            return (
                                <Box marginTop={'.5vw'}>
                                    <Typography fontSize={'1vw'} fontWeight={'bold'} >{`Admission Diagnosis`}</Typography>
                                    {valDisSum.admission_diagnosis?.length > 0 ? valDisSum.admission_diagnosis.map((data) => (
                                        <Box>
                                            <Typography >{`${data.icd_code}|${data.icd_short_desc}|${data.icd_desc}`}</Typography>
                                        </Box>
                                    )) : null}
                                    <Box>
                                        {textView(`Admission Provisional Dignosis`, disSumData.map((item) => item.template_data.provisional_diagnosis))}
                                    </Box>
                                </Box>
                            )
                        } else if (item.label === 'Discharge Diagnosis' && item.is_active === true) {
                            return (
                                <Box marginTop={'.5vw'}>
                                    <Typography fontSize={'1vw'} fontWeight={'bold'} >{item.label}</Typography>
                                    {valDisSum.discharge_diagnosis?.length > 0 ? valDisSum.discharge_diagnosis.map((data) => (
                                        <Typography>{`${data.icd_code}|${data.icd_short_desc}|${data.icd_desc}`}</Typography>
                                    )) : '-'}
                                </Box>
                            )
                        }
                        else if (item.label === 'Investigation and Test Report' && item.is_active === true) {
                            return (
                                <Box marginTop={'.5vw'}>
                                    {textView(`Invetigation`, valDisSum?.investigation_and_test_report?.investigation)}
                                    <Typography fontSize={'1vw'} fontWeight={'bold'} >{'Test Report'}</Typography>
                                    <Paper>
                                        <TableContainer>
                                            <Table size='small' aria-label="stictbl">
                                                <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                    <TableRow>
                                                        <TableCell fontWeight={'bold'} width={'10vw'}>{"S.No"}</TableCell>
                                                        <TableCell fontWeight={'bold'} width={'30vw'}>{"Test Name/Test Group"}</TableCell>
                                                        <TableCell fontWeight={'bold'} width={'30vw'}>{"Result"}</TableCell>
                                                        <TableCell fontWeight={'bold'} width={'20vw'}>{"Tested On"}</TableCell>
                                                        <TableCell fontWeight={'bold'} width={'10vw'}>{"Turn Over Time"}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {valDisSum?.investigation_and_test_report?.test_report?.length > 0 ? valDisSum?.investigation_and_test_report?.test_report?.map((list, i) => (
                                                        <TableRow>
                                                            <TableCell width={'10vw'}>{i + 1}</TableCell>
                                                            <TableCell width={'30vw'}>{(list.lab_test_name && list.lab_set_name) ? (list.lab_test_name + ' / ' + list.lab_set_name) : list.lab_test_name ? list.lab_test_name : list.lab_set_name ? list.lab_set_name : '-'}</TableCell>
                                                            <TableCell width={'30vw'}> {(list?.is_graph) ? <b style={{ fontSize: '0.8vw' }}>{"Result will be displayed in Print"}</b> : (list.is_culture) ? "this.culturTestView(list)" : list.result?.value ? list.result?.value : '-'}</TableCell>
                                                            <TableCell width={'20vw'}>{list.tested_on ? formatDateAndTimeMeth2(list.tested_on) : '-'}</TableCell>
                                                            <TableCell width={'10vw'}>{list.trun_over_time ? list.trun_over_time : '-'}</TableCell>
                                                        </TableRow>
                                                    )) : <TableCell colSpan={5} align='center'>{`No Records to Be Shown`}</TableCell>}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Box>
                            )
                        }
                        else if (item.label === 'Name Anaesthetist and Type of Anaesthesia' && item.is_active === true) {
                            return (
                                <Box marginTop={'.5vw'}>
                                    <Box>
                                        {textView(`Type of Anaesthesia`, valDisSum?.name_anaesthetist_and_type_of_anaesthesia?.type_of_anaesthesia)}
                                    </Box>
                                    <Box>
                                        {textView(`Name of Anaesthetist`, valDisSum?.name_anaesthetist_and_type_of_anaesthesia?.name_of_anaesthetist)}
                                    </Box>
                                </Box>
                            )
                        } else if (item.label === 'Vitals' && item.is_active === true) {
                            return (
                                <Box marginTop={'.5vw'}>
                                    <Typography fontSize={'1vw'} fontWeight={'bold'} >{'Vitals'}</Typography>
                                    <Paper>
                                        <TableContainer>
                                            <Table size='small' aria-label="stictbl">
                                                <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                    <TableRow>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>{`Date`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '8vw' }}>{`Height (cm)`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '8vw' }}>{`Weight (kg)`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '9vw' }}>{`BP (mm/Hg)`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '8vw' }}>{`Temp`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '8vw' }}>{`SpO2 (%)`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '8vw' }}>{`PulseRate / min`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '8vw' }}>{`Blood Glu (mg/DL)`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>{`Comments`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '15vw' }}>{`Nurse`}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {valDisSum.vitals?.length > 0 ? valDisSum.vitals?.map((list, i) => (
                                                        <TableRow>
                                                            <TableCell sx={{ width: '15vw' }}>{formatDateAndTime(list?.vital_entered_time)}</TableCell>
                                                            <TableCell sx={{ width: '8vw' }}>{list?.height_cm}</TableCell>
                                                            <TableCell sx={{ width: '8vw' }}>{list?.weight_kg}</TableCell>
                                                            <TableCell sx={{ width: '9vw' }}>{`${list?.blood_pressure_systolic || '-'}/${list?.blood_pressure_diastolic || '-'}`}</TableCell>
                                                            <TableCell sx={{ width: '8vw' }}>{`${list?.temperature || '-'} ${list?.temperature_unit || ''}`}</TableCell>
                                                            <TableCell sx={{ width: '8vw' }}>{list?.pulse_oximetry}</TableCell>
                                                            <TableCell sx={{ width: '8vw' }}>{list?.pulse_rate}</TableCell>
                                                            <TableCell sx={{ width: '8vw' }}>{list?.blood_sugar}</TableCell>
                                                            <TableCell sx={{ width: '15vw' }}>{list?.comments?.length > 12 ?
                                                                <Tooltip arrow title={list?.comments}>
                                                                    <div>{list?.comments.slice(0, 12) + "..."}</div>
                                                                </Tooltip> : list?.comments || "-"}</TableCell>
                                                            <TableCell sx={{ width: '15vw' }}>{list?.nurse_name?.length > 12 ?
                                                                <Tooltip arrow title={list?.nurse_name}>
                                                                    <div>{list?.nurse_name.slice(0, 12) + "..."}</div>
                                                                </Tooltip> : list?.nurse_name || "-"}</TableCell>
                                                        </TableRow>
                                                    )) : <TableCell colSpan={10} align='center'>{`No Records to Be Shown`}</TableCell>}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Box>
                            )
                        }
                        else if (item.label === 'Radiology Report' && item.is_active === true) {
                            return (
                                <Box marginTop={'.5vw'}>
                                    <Typography fontSize={'1vw'} fontWeight={'bold'} >{'Radiology Report'}</Typography>
                                    <Paper>
                                        <TableContainer>
                                            <Table size='small' aria-label="stictbl">
                                                <TableHead sx={{ backgroundColor: '#FAF9F9' }}>
                                                    <TableRow>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '5vw' }}>{`S.No`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>{`Service Type`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '50vw' }}>{`Service Name`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '20vw' }}>{`Result Status`}</TableCell>
                                                        <TableCell sx={{ fontWeight: 'bold', width: '5vw' }}>{`Action`}</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {valDisSum.radiology_report?.length > 0 ? valDisSum.radiology_report?.map((list, i) => (
                                                        <TableRow>
                                                            <TableCell sx={{ width: '5vw' }}>{i + 1}</TableCell>
                                                            <TableCell sx={{ width: '20vw' }}>{list?.service_type?.length > 20 ?
                                                                <Tooltip arrow title={list?.service_type}>
                                                                    <div>{list?.service_type.slice(0, 20) + "..."}</div>
                                                                </Tooltip> : list?.service_type || "-"}</TableCell>
                                                            <TableCell sx={{ width: '50vw' }}>{list?.service_name?.length > 20 ?
                                                                <Tooltip arrow title={list?.service_name}>
                                                                    <div>{list?.service_name.slice(0, 20) + "..."}</div>
                                                                </Tooltip> : list?.service_name || "-"}</TableCell>
                                                            <TableCell sx={{ width: '20vw' }}>{list?.result_status?.length > 20 ?
                                                                <Tooltip arrow title={list?.result_status}>
                                                                    <div>{list?.result_status.slice(0, 20) + "..."}</div>
                                                                </Tooltip> : list?.result_status || "-"}</TableCell>
                                                            <TableCell sx={{ width: '5vw' }}>
                                                                <IconButton onClick={() => { setisRadPrint(true); printRadiologyTest(list.id, list.radiology_id); }}>
                                                                    <Tooltip placement='top' title={'Print'} arrow>
                                                                        <img src={(radPrintEnable?.has(list?.result_status) && !isRadPrint) ? ImagePaths.PrintIcons.default : ImagePaths.LabPrintIconOff.default}
                                                                            className='eMed_Pat_Bill_img' alt='print' />
                                                                    </Tooltip>
                                                                </IconButton>
                                                            </TableCell>
                                                        </TableRow>
                                                    )) : <TableCell colSpan={5} align='center'>{`No Records to Be Shown`}</TableCell>}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Paper>
                                </Box>
                            )
                        }
                        else {
                            let vals = item.field_name
                            return (
                                <Box marginTop={'.5vw'}>
                                    {textView(item.label, valDisSum[vals])}
                                </Box>
                            )
                        }
                    }) : <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '5vh',}} className='eMed_DisSum_Tem_Nolayout'>{'Discharge Summary Not Found'}</Box>}
                </Box>
            </TriggerApiOnView>
            {errorMsg && <ToastMsg
                severity={'error'}
                msg={errorMsgText}
                msgPop={msgClose.bind(this)}
            />}
        </Box>
    )
}
